export const GET_GOAL = 'GET_GOAL';
export const SET_GOAL = 'SET_GOAL';
export const SET_GOAL_DETAILS_DATA = 'SET_GOAL_DETAILS_DATA';
export const SET_GOAL_CALC_RESULT = 'SET_GOAL_CALC_RESULT';
export const SET_CALCULATION_DATA = 'SET_CALCULATION_DATA';
export const SET_SELECTED_GOAL_BLOCK = 'SET_SELECTED_GOAL_BLOCK';
